import { useRef, useState } from "react";
import Drop from "../../components/esign/Drop";
import { pdfjs } from "react-pdf";
import { PDFDocument } from "pdf-lib";
import { blobToURL } from "../../utils/Utils";
import { AddSigDialog } from "../../components/esign/AddSigDialog";
import { BigButton } from "../../components/esign/BigButton";
import DraggableSignature from "../../components/esign/DraggableSignature";
import ViewPdf from "../../components/ViewPdf/ViewPdf";
import { LuPenLine, LuUser } from "react-icons/lu";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


const Esign = () => {

    const styles = {
        container: {
            // maxWidth: 530,
            // margin: "0 auto",
        },
        sigBlock: {
            // display: "inline-block",
            // border: "1px solid #000",
        },
        documentBlock: {
            maxWidth: 612,
            margin: "0 auto",
            // marginTop: 8,
            // border: "1px solid #999",
        },
        controls: {
            // maxWidth: 530,
            // margin: "0 auto",
            // marginTop: 8,
        },
    };

    const [pdf, setPdf] = useState('')
    const [oldPdf, setOldPdf] = useState('')
    const [signatureURL, setSignatureURL] = useState(false);
    const [position, setPosition] = useState(null);
    const [signatureDialogVisible, setSignatureDialogVisible] = useState(false);

    const [pageNum, setPageNum] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [pageDetails, setPageDetails] = useState(null);
    const documentRef = useRef(null)

    const bounds = { left: 0, top: 0, right: 558, bottom: 738 };

    const transformCoordinates = () => {
        const blockWidth = 550;
        const blockHeight = 730;

        // Трансформуємо координати відносно верхнього лівого кута блока
        const transformedX = position?.x;
        const transformedY = blockHeight - position?.y;

        // Обмежуємо координати розмірами блока
        const boundedX = Math.min(transformedX, blockWidth);
        const boundedY = Math.min(transformedY, blockHeight);

        return { x: boundedX, y: boundedY };
    }
    return (
        // <ContainerPage>
        <div className='flex max-w-[1360px] m-auto gap-6'>
            <div className='w-[438px]'>
                <div
                    className="flex flex-col items-start gap-6 p-6 rounded-2xl bg-paper border border-divider w-full max-w-[440px]">
                    <div className="stack flex flex-col items-start gap-4 self-stretch rounded-lg bg-paper">
                        <div className="flex flex-col items-start gap-2 self-stretch rounded-lg">
                            <div className="flex items-center gap-2 self-stretch py-4 px-3 rounded-lg">
                                <div
                                    className="flex justify-center items-center w-6 h-6 shrink-0 text-text-primary">
                                    <LuPenLine size={18} />
                                </div>
                                <div
                                    className="value h-6 overflow-hidden text-text-primary whitespace-no-wrap font-sans leading-[150%]">Add
                                    Signature
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-3 self-stretch">
                        <div className="flex flex-col items-start gap-4 self-stretch">
                            <div className="flex flex-col items-start gap-2 self-stretch rounded-lg">
                                <div
                                    className="flex items-center py-0 px-4 text-text-secondary font-sans text-sm leading-[150%]">
                                    Signer
                                </div>
                                <div
                                    className="flex items-center gap-2 self-stretch py-4 px-3 rounded-lg border border-divider value-1 h-6 overflow-hidden text-text-primary whitespace-no-wrap font-sans leading-[150%]">
                                    Just me
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="flex items-center justify-center p-2 text-text-secondary">
                                <LuUser size={18} />
                            </div>
                            <div className="text-text-primary font-sans text-sm font-semibold leading-[130%]">Send
                                to the user for signature
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end items-center gap-4 self-stretch py-6 px-0">
                        <div
                            className="button flex justify-center items-center gap-2 px-[22px] py-3.5 rounded-lg border border-divider text-text-primary font-sans text-sm font-semibold leading-[130%]">
                            Cancel
                        </div>
                        <div
                            className="button-1 flex justify-center items-center gap-2 px-[22px] py-3.5 rounded-lg bg-primary-main text-white font-sans font-semibold leading-[130%]">
                            Sign
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-surface w-full rounded-2xl border border-divider p-6'>
                <div style={styles.container}>
                    {signatureDialogVisible ? (
                        <AddSigDialog
                            onClose={() => setSignatureDialogVisible(false)}
                            setSignatureURL={setSignatureURL}
                            setSignatureDialogVisible={setSignatureDialogVisible}
                            onConfirm={(url) => {
                                setSignatureURL(url);
                                setSignatureDialogVisible(false);
                            }}
                        />
                    ) : null}

                    {!pdf ? (
                        <Drop
                            onLoaded={async (files) => {
                                const URL = await blobToURL(files[0]);
                                setPdf(URL);
                                setOldPdf(URL)
                            }}
                        />
                    ) : null}

                    {pdf ? (
                        <div>
                            <div style={styles.controls}>
                                {!signatureURL ? (
                                    <BigButton
                                        marginRight={8}
                                        title={"Add signature"}
                                        onClick={() => setSignatureDialogVisible(true)}
                                    />
                                ) : null}
                                {pdf ? (
                                    <BigButton
                                        marginRight={8}
                                        inverted={true}
                                        title={"Download"}
                                        onClick={() => {
                                            downloadURI(pdf, "file.pdf");
                                        }}
                                    />
                                ) : null}
                            </div>

                            <div ref={documentRef} style={styles.documentBlock}>

                                {signatureURL ? (
                                    <DraggableSignature
                                        bounds={bounds}
                                        url={signatureURL}
                                        onCancel={() => {
                                            setSignatureURL(null);
                                        }}
                                        onSet={async () => {
                                            const { originalHeight, originalWidth } = pageDetails;
                                            const scale =
                                                originalWidth / documentRef.current.clientWidth;

                                            // const y =
                                            //     documentRef.current.clientHeight -
                                            //     (position.y -
                                            //         // position.offsetY +
                                            //         64 -
                                            //         documentRef.current.offsetTop);
                                            // const x =
                                            //     position.x -
                                            //     160 -
                                            //     // position.offsetX -
                                            //     documentRef.current.offsetLeft;

                                            // new XY in relation to actual document size
                                            // const newY =
                                            //     (y * originalHeight) / documentRef.current.clientHeight;
                                            // const newX =
                                            //     (x * originalWidth) / documentRef.current.clientWidth;

                                            const pdfDoc = await PDFDocument.load(pdf);

                                            const pages = pdfDoc.getPages();
                                            const firstPage = pages[pageNum];

                                            const pngImage = await pdfDoc.embedPng(signatureURL);
                                            const pngDims = pngImage.scale(scale * 0.3);

                                            // const bounds = {left: 0, top: 0, right: 408, bottom: 588};

                                            // width: 612px;
                                            // height: 792px;
                                            const coordinates = transformCoordinates();
                                            firstPage.drawImage(pngImage, {
                                                x: coordinates?.x,
                                                y: coordinates?.y,
                                                width: pngDims.width,
                                                height: pngDims.height,
                                            });

                                            const pdfBytes = await pdfDoc.save();
                                            const blob = new Blob([new Uint8Array(pdfBytes)]);

                                            const URL = await blobToURL(blob);
                                            setPdf(URL);
                                            setPosition(null);
                                            setSignatureURL(null);

                                        }}
                                        onEnd={setPosition}
                                    />
                                ) : null}

                                <ViewPdf
                                    sePageN={setPageNum}
                                    totalPages={totalPages}
                                    pdf={pdf}
                                    setups={true}
                                    setTotalPages={setTotalPages}
                                    setPageD={setPageDetails}
                                />
                            </div>

                        </div>
                    ) : null}
                </div>
            </div>
        </div>
        // </ContainerPage>
    );
}

export default Esign;
